import React, { useEffect, useState } from 'react';
import './App.scss';
import Display from '../components/Display';
import Buttons from '../components/Buttons';


const App = () => {
  const [stageValues, setStateValues] = useState('');
  const [inputs, setInputs] = useState('');
  const [total, setTotal] = useState('0');
  const [evaluate, setEvaluate] = useState(false);

  const clear = (e) => {
    setInputs('');
    setStateValues('');
    setTotal('0');
  }

  const addSign = (e) => {
    const currentSign = e.target.innerText;

    if (evaluate) {  // if after been evaluated run this
      setEvaluate(false);
      setInputs(total + currentSign); // if the last inputs is evaluated, set total as inputs
    } else {
      setStateValues(currentSign); // set stageValues to currentSign
      setInputs(inputs + currentSign); // add the sign
    }
  }


  const toDecimal = () => {
    let decimal = '.';
    if(stageValues.includes('.')) return; // if it already a decimal return. no need for convertion.
    if(!stageValues || /[/+x-]$/.test(stageValues)) decimal = '0.'; // if not initial value or ends with any of these "/+x-", begin decimal with "0."
    setStateValues(stageValues + decimal); // stageValues + currentValue
    setInputs(inputs + decimal); // all inputs + decimal
  }


  const handleNumbers = (e) => {
    const currentValue = e.target.innerText;
    const newInitValue = stageValues.replace(/[/+x-]$/, '');
    setStateValues(newInitValue + currentValue); // stageValues + currentValue
    setInputs(inputs + currentValue); // all inputs + currentValue
  }

  const calculate = (e) => {
    let input = inputs.replace(/x/g,'*');
    if (!input || input=='0' || /=/g.test(input)) return; // if not input do nothing
    let strNum = ''+eval(input);
    let evaluate = `${eval(input)}`.length > 9? eval(input).toPrecision(9): eval(input);
    
    setInputs(input +' = '+evaluate);
    setTotal(evaluate+'');
    setStateValues('');
    setEvaluate(true);
  }


  const handleError = (currentValue) => {
    if(total.length > 10 || inputs.length > 20){
      setInputs('DIGIT LIMIT MET');
      setTimeout(() => setInputs(currentValue), 2000);
      return true;
    }
  }

  const result = stageValues || total;

  return (
    <div id="calculator">
      <Display result={result} input={inputs}/>
      <Buttons
        clear={clear}
        handleNumbers={handleNumbers}
        addSign={addSign}
        toDecimal={toDecimal}
        calculate={calculate}
      />
    </div>
  )
}



// class App extends React.Component {
//   constructor(props){
//     super(props);
//     this.state = {
//       input: '',
//       total: '0',
//       evaluated: false
//     }
//     this.getValue = this.getValue.bind(this);
//     this.specialChar = this.specialChar.bind(this);
//   }
//   getValue(e) {
//     let inputVal = this.state.input.replace(/^[0|\+|x|\/|\-]+$/,'');
//     let totalVal = this.state.total.replace(/^[0|\+|x|\/|\-]+$/,'');
//     let currentVal = (!totalVal && !/0$/.test(inputVal)) || this.state.evaluated || /[\+|x|\/|\-]$/.test(inputVal) ?
//         e.target.innerText.replace(/[\.]/,'0.'):
//         e.target.innerText;

//     if(totalVal.length > 10 || inputVal.length > 20){
//       this.setState({ total: currentVal, input: 'DIGIT LIMIT MET' })
//       setTimeout(() => { this.setState({ total:currentVal, input:currentVal}) }, 2000);
//       return;
//     }
//     if ( !(totalVal.includes(currentVal) && currentVal === '.')) {
//       if(this.state.evaluated) { // after been calculated
//         if('+-/x'.includes(currentVal)){ // if current value includes (+-/x) signs
//           this.setState({
//             total: currentVal,
//             input: totalVal + currentVal,
//             evaluated: false
//           })
//         } else {
//           this.setState({
//             total: currentVal,
//             input: currentVal,
//             evaluated: false
//           })
//         }
//       } else {
//         if('+-/x'.includes(currentVal)){
//           if(/[+\-\/x]$/.test(inputVal)) {
//              inputVal = inputVal.slice(0, -1);
//           }
//           this.setState({
//             input: inputVal + currentVal,
//             total: currentVal,
//             evaluated: false
//           })
//         } else {
//           this.setState({
//             input: inputVal + currentVal,
//             total: totalVal.replace(/[x\/\-\+]/g,'') + currentVal,
//             evaluated: false
//           })
//         }
//       }
//     }
//   }
//   specialChar(e) {
//     let char = e.target.innerText;
//     let input = this.state.input.replace(/x/g,'*');
//     if (char === '=') {
//       if(!input || input=='0' || /=/g.test(input)) return;
//       let strNum = ''+eval(input);
//       let evaluate = `${eval(input)}`.length > 9?
//           eval(input).toPrecision(9):
//           eval(input);
      
//       this.setState({
//         input: this.state.input +' = '+evaluate,
//         total: evaluate+'',
//         evaluated: true
//       })
//     } else if (char === 'AC') {
//       this.setState({
//         total: '0',
//         input: ''
//       })
//     }
//   }
//   render () {        
//     return (
//       <div id="calculator">
//         <DisplayOutput result={this.state.total} input={this.state.input}/>
//         <ButtonNums input={this.getValue} cal={this.specialChar}/>
//       </div>
//     )
//   }
// }


export default App;
